export { ResetPassword as ControlResetPassword } from "../reset-password";
